var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('UserDetailsCard')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('UserRelatedInfoCard')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('DocumentIndex',{attrs:{"resource-id":_vm.userId,"resource-type":"User"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }